import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  // Notifikasi Home Page
  {
    path: '/notification/',
    name: 'Notification Log',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['e1j-log-notification:read'])) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "notification" */ '@/router/views/notification/indexV2'),
  },
  {
    path: '/notification/',
    name: 'Notifikasi',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'e1b-web-umum:read',
            'e1c-web-dms:read',
            'e1a-web-perilakupengemudi:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "notification" */ '@/router/views/notification/index'),
  },

  // Perilaku Pengemudi Notifikasi
  {
    path: '/notification/driverbehavior/',
    name: 'Perilaku Pengemudi',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'e1a-web-perilakupengemudi:read',
            'alert_code:read',
            'raw_alerts_driver:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "notification" */ '@/router/views/notification/driverbehavior'),
  },

  // Perilaku Pengemudi Notifikasi Detail
  {
    path: '/notification/driverbehavior/map/:id',
    name: 'Perilaku Pengemudi Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'e1a-web-perilakupengemudi:read',
            'alert_code:read',
            'raw_alerts_driver:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '@/router/views/notification/driverbehavior/detailmap'
      ),
  },

  // Driver Monitoring System Notifikasi
  {
    path: '/notification/drivermonitoringsystem/',
    name: 'Driver Monitoring System',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'e1c-web-dms:read',
            'alert_code:read',
            'raw_alerts_driver:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '@/router/views/notification/drivermonitoringsystem'
      ),
  },

  // Perilaku Pengemudi Notifikasi Detail
  {
    path: '/notification/drivermonitoringsystem/map/:id',
    name: 'Driver Monitoring System Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'e1c-web-dms:read',
            'alert_code:read',
            'raw_alerts_driver:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '@/router/views/notification/drivermonitoringsystem/detailmap'
      ),
  },

  // Umum Notifikasi
  {
    path: '/notification/general/',
    name: 'General',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'e1b-web-umum:read',
            'alert_code:read',
            'raw_alerts_driver:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "notification" */ '@/router/views/notification/general'),
  },

  // Umum Notifikasi
  {
    path: '/notification/general/map/:id',
    name: 'General Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'e1b-web-umum:read',
            'alert_code:read',
            'raw_alerts_driver:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '@/router/views/notification/general/detailmap'
      ),
  },

  // Notifikasi Setting
  {
    path: '/notification/setting/',
    name: 'Notification Setting',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'e1b-web-umum:read',
            'e1c-web-dms:read',
            'e1a-web-perilakupengemudi:read',
            'e1g-web-adas:read',
          ]) &&
          store.getters['identity/hasAccess']([
            'e2a-popup-notifikasi:read',
            'e3a-email-notifikasi:read',
          ])
        ) {
          next()
        } else {
          next({ path: '/notification/' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '@/router/views/notification/notificationsetting'
      ),
  },

  //  Tambah Notifikasi Email
  {
    path: '/notification/setting/email',
    name: 'Email Notification Create',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'e1b-web-umum:read',
            'e1c-web-dms:read',
            'e1a-web-perilakupengemudi:read',
          ]) &&
          store.getters['identity/hasAccess'](['e3a-email-notifikasi:create'])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '@/router/views/notification/notificationsetting/detail/DeliveryForm'
      ),
  },

  //  Edit Notifikasi EMail
  {
    path: '/notification/setting/email/:id',
    name: 'Email Notification Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'e1b-web-umum:read',
            'e1c-web-dms:read',
            'e1a-web-perilakupengemudi:read',
          ]) &&
          store.getters['identity/hasAccess'](['e3a-email-notifikasi:update'])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '@/router/views/notification/notificationsetting/detail/DeliveryForm'
      ),
  },

  // Advanced Driver Assistance System Notifikasi
  {
    path: '/notification/adas/',
    name: 'Advanced Driver Assistance System',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'e1g-web-adas:read',
            'alert_code:read',
            'raw_alerts_adas:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "notification" */ '@/router/views/notification/adas'),
  },

  // Advanced Driver Assistance System Detail
  {
    path: '/notification/adas/map/:id',
    name: 'Advanced Driver Assistance System Detail',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccessAll']([
            'e1g-web-adas:read',
            'alert_code:read',
            'raw_alerts_adas:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Notifikasi' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "notification" */ '@/router/views/notification/adas/detailmap'),
  },

  {
    path: '/notification/detail/:id',
    name: 'Notification Detail',
    component: () =>
      import(
        /* webpackChunkName: "notification" */ '@/router/views/notification/components/detail/'
      ),
  },
]
